import { CheckPicker } from 'rsuite';

import './styles.css';

/**
 * Custom check picker component that applies the primary color of the custom theme to the checked state.
 * @component
 * @param {import('rsuite').CheckPickerProps} rest - Additional props to pass to the Toggle component.
 * @returns {JSX.Element} CustomCheckPicker component.
 */
export function CustomCheckPicker({ ...rest }) {
  return (
    <CheckPicker
      {...rest}
      className="custom-checkpicker"
    />
  );
}
